<template>
  <b-modal
      ref="modal"
      :title-html="name"
      :visible="visible"
      hide-footer
      no-close-on-backdrop
      size="xl"
      style="min-height: 500px;"
      @change="$emit('update:visible', $event)"
      @hidden="onClose || onHidden()"
  >
    <b-form @submit.prevent="handleSave">
      <b-form-group
          :invalid-feedback="item.errors.get('external_id')"
          :label="$t('External ID')"
          :label-for="`${uuid}_external_id`"
      >
        <b-form-input
            :id="`${uuid}_external_id`"
            v-model="item.external_id"
            :state="item.errors.has('external_id') ? false : null"
        />
      </b-form-group>

      <b-form-group
          :invalid-feedback="item.errors.get('description')"
          :label="$t('Description')"
          :label-for="`${uuid}_description`"
      >
        <b-form-input
            :id="`${uuid}_description`"
            v-model="item.description"
            :state="item.errors.has('description') ? false : null"
        />
      </b-form-group>

      <b-form-group
          :invalid-feedback="item.errors.get('amount')"
          :label="$t('Quantity')"
          :label-for="`${uuid}_amount`"
      >
        <b-form-input
            :id="`${uuid}_amount`"
            v-model="item.amount"
            :state="item.errors.has('amount') ? false : null"
            type="number"
        />
      </b-form-group>

      <b-form-group
          :invalid-feedback="item.errors.get('unit')"
          :label="$t('Unit')"
          :label-for="`${uuid}_unit`"
      >
        <b-form-input
            :id="`${uuid}_unit`"
            v-model="item.unit"
            :state="item.errors.has('unit') ? false : null"
        />
      </b-form-group>

      <b-form-group
          :invalid-feedback="item.errors.get('duration')"
          :label="$t('Duration')"
          :label-for="`${uuid}_duration`"
      >
        <b-form-input
            :id="`${uuid}_duration`"
            v-model="item.duration"
            :state="item.errors.has('duration') ? false : null"
        />
      </b-form-group>

      <b-form-group
          :invalid-feedback="item.errors.get('steps')"
          :label="$t('Steps')"
          :label-for="`${uuid}_steps`"
      >
        <b-form-input
            :id="`${uuid}_steps`"
            v-model="item.steps"
            :state="item.errors.has('steps') ? false : null"
            type="number"
        />
      </b-form-group>

      <b-form-checkbox
          v-if="!hideCoveredCheckbox"
          :id="`${uuid}_covered`"
          v-model="item.covered"
          :name="item.id + '_covered'"
          :unchecked-value="false"
          :value="true"
          class="mb-3"
      >
        {{ $t('Covered') }}
      </b-form-checkbox>

      <b-button-group>
        <b-button :disabled="item.busy" class="ml-auto" type="submit" variant="primary">
          {{ $t('Save') }}
          <b-spinner v-show="item.busy" small />
        </b-button>

        <issue-button :project-id="projectId" :subject="fullUrl($route.fullPath)" />
      </b-button-group>
    </b-form>
  </b-modal>
</template>

<script>
    import FoundationSelect from '@/components/selects/ResourceSelect';
    import ServicesSelect from '@/components/ServicesSelect';
    import WALLS_FIELDS_LOOKUP from "@/constants/walls_fields_lookup";
    import {WALL_TYPES} from "@/constants";

    import {sortBy} from 'lodash';
    import itemMixin from "@/mixins/itemMixin";
    import WallsTreeSelect from "@/components/selects/WallsTreeSelect";
    import IssueButton from "@/components/issues/IssueButton.vue";

    export default {
        name: "ProjectServiceCreateView",
        components: {IssueButton, WallsTreeSelect, ServicesSelect, FoundationSelect},
        mixins: [itemMixin],
        props: {
            projectId: { //id in URL, passed by router
                type: [Number, String],
                required: true,
            },
            visible: {
                type: Boolean,
                default: true
            },
            onClose: {
                type: Function,
                default: null
            }
        },
        computed: {
            resourceName() {
                return `projects/${this.projectId}/available_services`;
            },

            servicesMultipliers() {
                return (WALLS_FIELDS_LOOKUP[this.item.type] || []).filter(field => field.append === 'm');
            },

            types() {
                let types = Object.values(WALL_TYPES).map(type => {
                    return {
                        value: type,
                        text: this.$t(type),
                    }
                })


                return sortBy(types, 'text');
            }
        },

        beforeEnter: (to, from, next) => {
            if (this.$gate.allow('create', 'service')) {
                next();
            } else {
                this.forbiddenToast(this.$t('You are not allowed to create services'));
                next({name: 'projects.services', params: to.params})
            }
        },

        // beforeUpdate(to, from) {
        //     if (this.$gate.allow('create', 'foundation')) {
        //         this.$refs.modal.show();
        //     } else {
        //         this.forbiddenToast(this.$t('You are not allowed to create foundations'));
        //         next({name: 'projects.foundations', params: to.params})
        //     }
        // },

        methods: {
            handleDuplicate() {
                this.$set(this.item, 'id', null);
                this.$set(this.item, 'name', null);

                this.$refs.name.focus();
            },

            onHidden() {
                this.$router.push({name: 'projects.services', params: {projectId: this.projectId}})
            },
        }
    }
</script>

<style scoped>
 >>> #floor_id .multiselect__content-wrapper {
     position: relative;
 }
</style>
